/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function tickerSlider() {
  let tickerSlideshows = document.querySelectorAll('.ticker-slideshow');
  console.log(tickerSlideshows)
  tickerSlideshows.forEach((element) => {
    let pauseOnHover = element.getAttribute('data-pause-on-hover');
    //
    //   Variables
    //
    //////////////////////////////////////////////////////////////////////

    // Play with this value to change the speed
    let tickerSpeed = 1;

    let tickerFlickity = null;
    let isPaused = false;
    let slideshowEl = element;

    if (slideshowEl != null) {
      //
      //   Functions
      //
      //////////////////////////////////////////////////////////////////////

      let update = () => {
        if (isPaused) return;
        if (tickerFlickity.slides) {
          tickerFlickity.x = (tickerFlickity.x - tickerSpeed) % tickerFlickity.slideableWidth;
          tickerFlickity.selectedIndex = tickerFlickity.dragEndRestingSelect();
          tickerFlickity.updateSelectedSlide();
          tickerFlickity.settle(tickerFlickity.x);
        }
        window.requestAnimationFrame(update);
      };

      let pause = () => {
        isPaused = true;
      };

      let play = () => {
        if (isPaused) {
          isPaused = false;
          window.requestAnimationFrame(update);
        }
      };


      //
      //   Create Flickity
      //
      //////////////////////////////////////////////////////////////////////

      tickerFlickity = new Flickity(slideshowEl, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25
      });
      tickerFlickity.x = 0;


      if (pauseOnHover == 'true') {
        //
        //   Add Event Listeners
        //
        //////////////////////////////////////////////////////////////////////

        slideshowEl.addEventListener('mouseenter', pause, false);
        slideshowEl.addEventListener('focusin', pause, false);
        slideshowEl.addEventListener('mouseleave', play, false);
        slideshowEl.addEventListener('focusout', play, false);

        tickerFlickity.on('dragStart', () => {
                                isPaused = true;
                                });
      }


      //
      //   Start Ticker
      //
      //////////////////////////////////////////////////////////////////////

      update();
    }
  });
};

document.addEventListener("DOMContentLoaded", function(event) { 
	tickerSlider()

     function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }

  document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('product_variant_input')) {

      let isAvailable = el.dataset.variant_available;

      let mainParentEl = el.closest('.ProductItem');
      let onSaleEl = mainParentEl.querySelector('.ProductItem__Label--onSale');
      let addToCartButton = mainParentEl.querySelector('.ProductForm__AddToCart');
      
      if(addToCartButton) {
           addToCartButton.classList.remove('Button--secondary');
          addToCartButton.classList.remove('Button--primary');
      
        if (isAvailable == 'true') {
              addToCartButton.removeAttribute('disabled');
              addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
              addToCartButton.setAttribute('data-action', 'add-to-cart');
                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
            } else {
              addToCartButton.setAttribute('disabled', 'disabled');
              addToCartButton.classList.add('Button--secondary');
              addToCartButton.removeAttribute('data-action');
              addToCartButton.innerHTML = window.languages.productFormSoldOut;
            }
      }

            let itemPriceEl =  mainParentEl.querySelector('.ProductItem__PriceList');
      if(itemPriceEl) {
          let variantPrice = el.dataset.variant_price * 1;
        let variantComparePrice = el.dataset.variant_compare_price * 1 ;
        let currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

         itemPriceEl.style.display = 'none';
          itemPriceEl.innerHTML = '';

          if (variantComparePrice > variantPrice) {
            itemPriceEl.innerHTML += "<span class=\"ProductItem__Price Price Price--highlight Text--subdued\" >".concat(formatMoney(variantPrice, currencyFormat), "</span>");
            itemPriceEl.innerHTML += "<span class=\"ProductItem__Price Price Price--compareAt Text--subdued\" >".concat(formatMoney(variantComparePrice, currencyFormat), "</span>");

            if(onSaleEl) {
            onSaleEl.classList.remove('no-js');
            }
          } else {
             if(onSaleEl) {
            onSaleEl.classList.add('no-js');
            }
            itemPriceEl.innerHTML += "<span class=\"ProductItem__Price Price Text--subdued\" >".concat(formatMoney(variantPrice, currencyFormat), "</span>");
          }
          itemPriceEl.style.display = '';
      }
      

      
    }
  });
  
});
 
